module.exports = __webpack_public_path__ + "img/card-step-instructions.8e9f7d4c.png";